<aside class="side-nav" aria-label="Main navigation">
    <div class="side-nav__header">
        <div class="side-nav__brand">Q.</div>
        <button
                type="button"
                class="side-nav__toggle"
                [attr.aria-label]="isExpanded ? 'Collapse navigation' : 'Expand navigation'"
                [attr.aria-expanded]="isExpanded"
                (click)="toggle()"
        >
            {{ isExpanded ? '‹' : '›' }}
        </button>
    </div>

    <nav class="side-nav__menu">
        <a
                *ngFor="let item of navItems"
                class="side-nav__item"
                [routerLink]="item.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                [title]="!isExpanded ? item.label : null"
        >
            <span class="side-nav__icon">{{ item.icon }}</span>
            <span class="side-nav__label">{{ item.label }}</span>
        </a>
    </nav>

    <div class="side-nav__footer">
        <button type="button" class="side-nav__item" [title]="!isExpanded ? 'Einstellungen' : null">
            <span class="side-nav__icon">⚙</span>
            <span class="side-nav__label">Einstellungen</span>
        </button>
    </div>
</aside>
